import React from 'react';
import { PAYMENT_CONDITION } from '@monorepo/dictionary';
import { SelectField, TFormField } from '@monorepo/forms';
import { enumToSelectOptions } from '@monorepo/helpers';
import { prepareOptions } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';

// Deprecated payment conditions that should be disabled for new entries
const DEPRECATED_CONDITIONS = ['3', '6', '7', '8', '9'];

const PaymentConditionSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  const options = prepareOptions(
    enumToSelectOptions(PAYMENT_CONDITION),
    t,
    'paymentcondition.'
  )
    .map((option) => ({
      ...option,
      disabled: DEPRECATED_CONDITIONS.includes(option.value.toString())
    }))
    .sort((a, b) => {
      // Незаблокированные опции сверху, заблокированные внизу
      if (a.disabled === b.disabled) return 0;
      return a.disabled ? 1 : -1;
    });

  return (
    <SelectField<TFormValues>
      options={options}
      {...props}
    />
  );
};

export default PaymentConditionSelect;
